/**
 *
 *
 */

import RiskFactor from './risk-factor';

export default class CVVCode extends RiskFactor {
    icon = 'credit-card';

    label = '<span class="has-tooltip has-tooltip-help" data-tooltip="Card Verification Value">CVV</span> Code';

    static getCondition({cvvResponse}) {
        return !!cvvResponse && cvvResponse.code !== null;
    }

    parse({cvvResponse}) {
        this.cvvResponse = cvvResponse;
    }

    getResult() {
        return this.cvvResponse.code;
    }
}
